import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const borderSubtle = '#e0e4ec';

/** List container — matches ProviderSignup input/chrome (soft border, light fill). */
export const ResultsCard = styled(Box)(({ theme }) => ({
  border: `2px solid ${borderSubtle}`,
  borderRadius: 10,
  maxHeight: 320,
  overflow: 'auto',
  marginTop: theme.spacing(1.5),
  background: '#fafbfd',
}));

export const FooterHint = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  textAlign: 'center',
  fontSize: '0.875rem',
  color: '#555',
  lineHeight: 1.5,
  '& a': {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontWeight: 600,
    color: '#0d4efe',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
      textUnderlineOffset: '3px',
    },
  },
}));
